import React from 'react';
import { Stack, Toaster, Toast, createToaster } from '@chakra-ui/react';

export const toaster = createToaster({
  placement: 'top-end',
  overlap: true,
});

const AppToaster: React.FC = () => {
  return (
    <Toaster toaster={toaster}>
      {(toast) => (
        <Toast.Root key={toast.id} width={{ md: 'sm' }}>
          <Toast.Indicator />
          <Stack gap={1} flex="1" minW={0} maxW="100%">
            {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
            {toast.description && (
              <Toast.Description>{toast.description}</Toast.Description>
            )}
          </Stack>
          <Toast.CloseTrigger />
        </Toast.Root>
      )}
    </Toaster>
  );
};

export default AppToaster;
